import DriveFileMoveOutlined from "@mui/icons-material/DriveFileMoveOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { MoveProgramDialog } from "./move-program-dialog";

import type { ProgramNode, ProgramTree } from "../../program-tree/program-tree";
import type { FC } from "react";

/**
 * The More actions menu of a program, on its page or on the landing page, to move the program or
 * folder. Only for an admin.
 */
export const ProgramActionsMenu: FC<{
  tree: ProgramTree;
  program: ProgramNode;
  /** After it moves, and after it moves back, so that the programs can load again. */
  onMoved: () => void;
  /** The button's name, where more than one program shows. */
  label?: string;
  /** The start of the analytics ids, for the place that the menu is in. */
  analyticsPrefix?: string;
}> = ({ tree, program, onMoved, label = "More actions", analyticsPrefix = "program-page" }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <IconButton
        aria-label={label}
        aria-haspopup="menu"
        aria-expanded={anchor !== null}
        onClick={(event) => setAnchor(event.currentTarget)}
        data-analytics-id={`${analyticsPrefix}-more`}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchor} open={anchor !== null} onClose={() => setAnchor(null)}>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            setDialogOpen(true);
          }}
          data-analytics-id={`${analyticsPrefix}-move`}
        >
          <ListItemIcon>
            <DriveFileMoveOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>{program.parent_id ? "Move folder…" : "Move program…"}</ListItemText>
        </MenuItem>
      </Menu>
      <MoveProgramDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        tree={tree}
        program={program}
        onMoved={onMoved}
      />
    </>
  );
};
